import { createFileRoute, Outlet } from "@tanstack/react-router";

import React from "react";
import { useTranslation } from "react-i18next";
import { Tab, TabMenu } from "src/components/base/tab-menu";
import TabLayout from "src/components/base/tab-layout";
import { BackButton } from "src/components/base/button";
import SINGLE_TAG_CONTEXT, { SingleTagProvider } from "src/context/internal/tag";
import { Badge } from "src/components/base/badges/base";
import { LockClosedIcon } from "@heroicons/react/20/solid";

/**
 * The properties for {@link SingleTagView}
 */
export type TagLayout = {};

/**
 * The Layout for a single tag
 */
function SingleTagView(props: TagLayout) {
    const [t] = useTranslation("admin-tag");

    const { tagId } = Route.useParams();

    return (
        <SingleTagProvider uuid={tagId}>
            <SINGLE_TAG_CONTEXT.Consumer>
                {(ctx) => (
                    <div className={"flex flex-col gap-6"}>
                        <BackButton className={"self-start"} href={"/a/tags"}>
                            {t("button.back-to-tag-overview")}
                        </BackButton>

                        <TabLayout
                            heading={t("heading.tag", { tag: ctx.tag.name })}
                            headingDescription={
                                ctx.tag.locked ? (
                                    <Badge color={"orange"}>
                                        <LockClosedIcon className={"size-4"} />
                                        <span>{t("label.read-only")}</span>
                                    </Badge>
                                ) : undefined
                            }
                            tabs={
                                <TabMenu>
                                    <Tab href={"/a/tags/$tagId/associated"} params={{ tagId }}>
                                        {t("label.associated-devices")}
                                    </Tab>
                                    <Tab href={"/a/tags/$tagId/inbound-acls"} params={{ tagId }}>
                                        {t("label.inbound-acls")}
                                    </Tab>
                                    <Tab href={"/a/tags/$tagId/outbound-acls"} params={{ tagId }}>
                                        {t("label.outbound-acls")}
                                    </Tab>
                                </TabMenu>
                            }
                        >
                            <Outlet />
                        </TabLayout>
                    </div>
                )}
            </SINGLE_TAG_CONTEXT.Consumer>
        </SingleTagProvider>
    );
}

export const Route = createFileRoute("/_admin/a/tags/$tagId/_tags")({
    component: SingleTagView,
});
